import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3ikr002qv3a7b">
      <noscript data-id="element-1" data-mp="3ml14tc2x3ukl">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3mkrgru1fnxhj" />
      </noscript>
      <Hero data-id="element-3" data-mp="5ggje8nxyxz" />
      <ProfessionalAudience data-id="element-4" data-mp="56qxrrj5tst" />
      <StatsBar data-id="element-5" data-mp="2zld1d7i6tbah" />
      <TestimonialStrip data-id="element-6" data-mp="2zllijblcf2rh" />
      <Problems data-id="element-7" data-mp="2zmenc70qri6z" />
      <Modules data-id="element-8" data-mp="2zmwggus3xgao" />
      <ModuleIncludes data-id="element-9" data-mp="2zng0ch1bierc" />
      <Comparison data-id="element-10" data-mp="33mf623uvifju" />
      <Bonuses data-id="element-11" data-mp="33lx18iu5at0b" />
      <PricingPack data-id="element-12" data-mp="33ngfy505kvzz" />
      <Guarantee data-id="element-13" data-mp="33myjb79kwfrj" />
      <Reviews data-id="element-14" data-mp="33oi0d0326uud" />
      <CostOfNotBuying data-id="element-15" data-mp="38m1f013o59mu" />
      <FAQ data-id="element-16" data-mp="38kqce4lym7xb" />
      <FinalCTA data-id="element-17" data-mp="38l06a3a4kz8a" />
      <Footer data-id="element-18" data-mp="38kgm0fx05yr3" />
    </main>;
}